import { useEffect } from 'react';
import { IsIdle } from './is-idle';
export const Idle = ({ onIdle }) => {
    useEffect(() => {
        const isIdle = new IsIdle({ onIdle });
        isIdle.start();
        return () => {
            isIdle.stop();
        };
    }, [onIdle]);
    return null;
};
